import React, { useState } from "react";
import { Link } from "react-router-dom";

/* 🔴 teamMembers ARRAY = EXACT SAME AS YOU PROVIDED (NO CHANGE) */
const teamMembers = [
  {
    name: "डॉ अमरदीप",
    title: "अध्यक्ष",
    image: "/assests/img/members/Chairman_Dr_Amardeep.png",
    mobileNo: "966831012 / 8969490912",
    emailId: "scpcr.bihar@gmail.com",
    description: "",
  },
  {
    name: "डॉ. हुलेश माँझी",
    title: "सदस्य",
    image: "/assests/img/members/Dr_Hulesh_Manjhi.png",
    mobileNo: "8986020982 / 8294627765",
    emailId: "scpcr.bihar@gmail.com",
    description: `डॉ. हुलेश माँझी पटना जिले के फुलवारी शरीफ प्रखंड के परसा बाजार थाना क्षेत्र के ग्राम पलंगा के रहने वाले हैं। इनकी प्रारंभिक एवं माध्यमिक शिक्षा गांव के विद्यालय से ही हुई है। वर्ष 2003 में पटना विश्वविद्यालय से भूगोल विषय में स्नातक करने के उपरांत 2006 में भूगोल विषय में ही स्नातकोत्तर किया है। इन्होंने 2007 में UGC, NET की परीक्षा उर्तीण की एवं 2008 में UGC (RNGF) रिसर्च में फेलोशिप भी प्राप्त किया। वर्ष 2009 में हुलेश माँझी नालंदा खुला विश्वविद्यालय पटना से "पिछड़े क्षेत्र में सतत विकास के लिए कार्ययोजनाः अरवल जिला के परिप्रेक्ष्य में एक अध्ययन " विषय में अपना शोध कार्य पूर्ण किया है। वर्तमान में डॉ. माँझी स्वामी सहजानन्द महाविद्यालय में भूगोल विभाग में सहायक प्राध्यापक हैं। 2015 में श्री माँझी बिहार राज्य महादलित आयोग के अध्यक्ष के रूप में कार्य कर चुके हैं।`,
  },
  {
    name: "श्रीमती संगीता ठाकुर",
    title: "सदस्य",
    image: "/assests/img/members/Srimati_Sangita_Thakur.png",
    mobileNo: "8709908784 / 9546082197",
    emailId: "scpcr.bihar@gmail.com",
    description: `श्रीमती संगीता ठाकुर की पहचान एक प्रख्यात समाजसेवी की है। इन्होंने कैपिटल यूनिवर्सिटी से वाणिज्य विषय में स्नातक किया है। छात्र जीवन से ही ये समाज सेवा से जुड़ी रही हैं। 2002 से 2008 तक श्रीमती संगीता ठाकुर मध्य विद्यालय (बालक) राजनगर, मधुबनी के शिक्षा समिति की अध्यक्ष रही। इस पद पर रहते हुए इन्होंने बच्चों को विद्यालय से जोड़ने का कार्य किया। 2006 में जिला परिषद् का चुनाव जीतकर 2008 से 2011 तक मधुबनी जिला परिषद् के लोक स्वास्थ्य अभियंत्रण समिति के अध्यक्ष का पदभार संभाला। विभिन्न सामाजिक संगठनों से जुड़कर महिलाओं को अपने अधिकारों के प्रति जागरूक करने, शारीरिक और मानसिक स्वास्थ्य के लिए शराबबंदी की आवश्यकता, बाल विवाह रोको अभियान इत्यादि आज भी तत्परता से चला रही हैं।`,
  },
  {
    name: "श्रीमती डॉ. ज्योति कुमारी",
    title: "सदस्य",
    image: "/assests/img/members/Srimati_Jyoti_Kumari.png",
    mobileNo: "6200746994",
    emailId: "scpcr.bihar@gmail.com",
    description: `डॉ. ज्योति कुमारी एक शिक्षाविद् एवं सामाजिक कार्यकर्ता हैं। इन्होंने ललित नारायण मिथिला विश्वविद्यालय से मनोविज्ञान विषय में डॉक्टरेट की उपाधि प्राप्त की हैं तथा वर्तमान में M.P.S. Science College, में मनोविज्ञान की सहायक प्राध्यापक पद पर पदस्थापित हैं। समाज में महिलाओं एवं बच्चों के विकास के लिए तथा उनके अधिकारों के संरक्षण हेतु जिला एवं प्रदेश स्तर तक संबंधित संस्थाओं के साथ मिलकर कार्य किया है। ये समस्तीपुर जिला में पंचायत के मुखिया पद पर भी आसीन रही हैं। डॉ. ज्योति पंचायत के लोगों के बीच रहकर उनके विकास के लिए सतत् प्रयासरत रहती हैं। सरकार के द्वारा बच्चों, महिलाओं एवं छात्र-छात्राओं से जुड़ी जानकारी लोगों के बीच जाकर देती हैं ताकि लोगों को अधिक से अधिक योजनाओं का लाभ मिल सके।`,
  },
  {
    name: "डॉ. सुग्रीव दास",
    title: "सदस्य",
    image: "/assests/img/members/Dr_Sugriv_Das.png",
    mobileNo: "9470649323 / 9155654177",
    emailId: "scpcr.bihar@gmail.com",
    description: `डॉ. सुग्रीव दास की ख्याति समाजसेवी और मानवतावादी के रूप में रही है। उन्होंने तिलकामांझी भागलपुर विश्वविद्यालय से स्नातक की शिक्षा प्राप्त करने के उपरान्त मधेपुरा विश्वविद्यालय से इतिहास विषय में स्नातकोतर और पी.एच.डी. की उपाधि प्राप्त की। वर्ष 2008 में कोसी क्षेत्र में बाढ़ एवं 2020-21 में कोरोना महामारी के समय उनके मानवीय कार्यों की सराहना हुई।`,
  },
  {
    name: "डॉ राकेश कुमार सिंह",
    title: "सदस्य",
    image: "/assests/img/members/shree_Rakesh_Singh.png",
    mobileNo: "8210195662 / 9608081632",
    emailId: "scpcr.bihar@gmail.com",
    description: `श्री राकेश कुमार सिंह वर्ष 1988 से ही सामाजिक एवं राजनीतिक कार्य में सक्रिय रहे हैं। इन्होंने ए. एन. कॉलेज, पटना से लोक प्रशासन विषय में स्नातकोत्तर की उपाधि प्राप्त की हैं। बच्चों, महिलाओं एवं कमजोर वर्गों को सरकारी योजनाओं का लाभ दिलाने हेतु निरंतर प्रयासरत रहते हैं।`,
  },
];

function TeamSection() {
  const [selectedMember, setSelectedMember] = useState(null);

  const chairman = teamMembers.find(m => m.title === "अध्यक्ष");
  const members = teamMembers.filter(m => m.title !== "अध्यक्ष");

  return (
    <div className="container-xxl">
      <div className="container">

        {/* ================= HEADING ================= */}
        <div className="text-center mx-auto mb-3" style={{ maxWidth: 650 }}>
          <h6 className="section-title bg-white text-center text-primary px-3">
            हमारी टीम
          </h6>
          {/* <h1 className="display-6 mb-4">
            आपके सपनों के प्रोजेक्ट के लिए एक समर्पित टीम
          </h1> */}
        </div>

{/* ================= CHAIRMAN BANNER ================= */}
{chairman && (
  <div className="row justify-content-center mb-5">
    <div className="col-lg-10">
      <div
        className="position-relative bg-gradient rounded-4 shadow-lg p-4 p-lg-5 d-flex flex-column flex-lg-row align-items-center justify-content-center gap-4"
        style={{
          borderTop: "6px solid #0d6efd",
          background: "linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)",
        }}
      >
        {/* ===== IMAGE (OVERLAP EFFECT) ===== */}
        <div
          className="text-center flex-shrink-0"
          style={{ marginTop: "-20px" }}
        >
          <img
            src={chairman.image}
            alt={chairman.name}
            className="rounded-circle border border-4 border-white shadow"
            style={{
              width: "220px",
              height: "220px",
              objectFit: "cover",
            }}
          />
        </div>

        {/* ===== CONTENT ===== */}
        <div className="flex-grow-1 text-center text-lg-start">
          <h2 className="mb-2">{chairman.name}</h2>
          <span className="badge bg-primary mb-3 fs-6">{chairman.title}</span>

          <p className="mt-2 mb-1">📞 {chairman.mobileNo}</p>
          <p className="mb-3">✉️ {chairman.emailId}</p>

          {chairman.description && (
            <p style={{ lineHeight: "1.7", fontSize: "15px" }}>
              {chairman.description}
            </p>
          )}

          <Link
            to="/Chairman"
            className="btn btn-primary rounded-pill px-4 py-2 fw-semibold mt-2"
          >
            पूरा विवरण देखें
          </Link>
        </div>
      </div>
    </div>
  </div>
)}

        {/* ================= MEMBERS GRID ================= */}
        <div className="row g-4">
          {members.map((member, idx) => (
            <div key={idx} className="col-lg-4 col-md-6">
              <div
                className="member-card bg-white rounded-4 shadow-sm p-4 text-center h-100"
                style={{
                  transition: "all 0.35s ease",
                }}
              >
                <img
                  src={member.image}
                  alt={member.name}
                  className="rounded-circle mb-3"
                  style={{
                    width: "200px",
                    height: "200px",
                    objectFit: "cover",
                    border: "4px solid #dee2e6",
                  }}
                />

                <h5>{member.name}</h5>
                <small className="text-primary fw-semibold">
                  {member.title}
                </small>

                <div className="mt-3">
                  <p className="mb-1">📞 {member.mobileNo}</p>
                  <p className="mb-2">{member.emailId}</p>

                  <button
                    className="btn btn-outline-primary btn-sm"
                    onClick={() => setSelectedMember(member)}
                  >
                    पूरा विवरण देखें
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* ================= GLASS MODAL ================= */}
        {selectedMember && (
          <div
            className="modal fade show"
            style={{
              display: "block",
              background: "rgba(0,0,0,0.65)",
              backdropFilter: "blur(6px)",
            }}
          >
            <div className="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
              <div
                className="modal-content rounded-4"
                style={{
                  background: "rgba(255,255,255,0.85)",
                  backdropFilter: "blur(10px)",
                }}
              >
                <div className="modal-header">
                  <h5 className="modal-title">
                    {selectedMember.name} ({selectedMember.title})
                  </h5>
                  <button
                    className="btn-close"
                    onClick={() => setSelectedMember(null)}
                  />
                </div>

                <div className="modal-body">
                  <p style={{ lineHeight: "1.9", whiteSpace: "pre-line" }}>
                    {selectedMember.description}
                  </p>
                </div>

                <div className="modal-footer">
                  <button
                    className="btn btn-secondary"
                    onClick={() => setSelectedMember(null)}
                  >
                    बंद करें
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}

      </div>

      {/* ================= HOVER EFFECT ================= */}
      <style>{`
        .member-card:hover {
          transform: translateY(-10px) scale(1.02);
          box-shadow: 0 18px 40px rgba(0,0,0,0.15);
        }
      `}</style>
    </div>
  );
}

export default TeamSection;
